import Vue from 'vue'
import apis from '@/api'
// import { isIos } from '@/lib/ui/utils/platform.util.js'

export function weComSdkInit() {
  const store = require('../../store/index.js')
  const weComInfo = store.default.state.authModule.weComInfo
  if (!weComInfo) {
    Vue.prototype.$weComConfigStatus = false
    return
  }
  // if (isIos() && Vue.prototype.$weComConfigStatus) {
  //   return
  // }
  if (window.wx) {
    signatureConfig(weComInfo)
  } else {
    const s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'http://res.wx.qq.com/open/js/jweixin-1.2.0.js'
    const weComElement = document.body.appendChild(s)
    weComElement.onload = () => {
      signatureConfig(weComInfo)
    }
  }
}

function signatureConfig(weComInfo) {
  const url = window.location.href
  const jsApiList = ['getLocation', 'scanQRCode']
  const request = { ...apis.ACCOUNT.WECOM_SIGN }
  request.params = {
    url,
    ...weComInfo
  }
  window.wx.error((res) => {
    Vue.prototype.$weComConfigStatus = false
    // console.log(res)
    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
  })
  window.wx.ready((res) => {
    Vue.prototype.$weComConfigStatus = true
    // console.log(res)
  })
  Vue.prototype
    .$request(request, false)
    .asyncThen(
      (resp) => {
        window.wx.config({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: resp.data.appId,
          signature: resp.data.signature,
          nonceStr: resp.data.nonceStr,
          timestamp: resp.data.timestamp,
          jsApiList
        })
        window.wx.error((res) => {
          Vue.prototype.$weComConfigStatus = false
          // console.log(res)
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
        window.wx.ready((res) => {
          Vue.prototype.$weComConfigStatus = true
          Vue.prototype.$bus.$emit(`getLocationEvent`, '', {
            opt: 'STARTS_WITH'
          })
          // console.log(res)
        })
      },
      (err) => {
        Vue.prototype.$weComConfigStatus = false
        console.error(err)
      }
    )
    .asyncErrorCatch((err) => {
      Vue.prototype.$weComConfigStatus = false
      console.error(err)
    })
}

export function weComScanQRCode(callback) {
  window.wx.scanQRCode({
    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
    success: function (res) {
      var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
      callback({
        result
      })
    },
    fail: (error) => {
      callback()
    },
    cancel: (error) => {
      callback()
    }
  })
}

export function weComGetLocation(showMessage, callback) {
  window.wx.getLocation({
    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    success: (res) => {
      var lat = res.latitude // 纬度，浮点数，范围为90 ~ -90
      var lng = res.longitude // 经度，浮点数，范围为180 ~ -180。
      callback({
        lat,
        lng
      })
    },
    fail: (error) => {
      if (showMessage) {
        Vue.prototype.$message({
          type: 'error',
          message: `企业微信定位失败，请稍后重试`
        })
      }
      callback()
    },
    cancel: (error) => {
      if (showMessage) {
        Vue.prototype.$message({
          type: 'error',
          message: `企业微信定位失败，请稍后重试`
        })
      }
      callback()
    }
  })
}
